﻿<template>
    <div class="w-full">

        <!--If statement for when passanger count if > 5 to change formatting to rows-->
        <div class="mt-1 relative">
            <!--Desktop View-->
            <div class="flex flex-wrap" :class="{'hidden': isMobile()}">
                <div v-for="(passenger, index) in passengers" @click="Toggle_Passenger(passenger)">
                    <div class="flex items-center">
                        <input :id="passenger.passenger_identifier" type="checkbox" :checked="Passenger_Selected(passenger)" class="ml-10 focus:ring-action -mt-1 h-4 w-4 text-action border-grey-light rounded">
                        <label :for="passenger.passenger_identifier" class="ml-3 block text-sm cursor-pointer">{{passenger.first_name}} {{passenger.familiy_name}}</label>
                    </div>
                </div>
            </div>

            <!--Mobile view-->
            <div v-if="passengers.length < 6" :class="{'hidden': !isMobile()}">
                <div class="mb-1 mr-0" v-for="(passenger, index) in passengers" @click="Toggle_Passenger(passenger)">
                    <div class="flex items-center">
                        <input :id="passenger.passenger_identifier" type="checkbox" :checked="Passenger_Selected(passenger)" class="ml-10 focus:ring-action -mt-1 h-4 w-4 text-action border-grey-light rounded">
                        <label :for="passenger.passenger_identifier" class="ml-3 block text-sm cursor-pointer">{{passenger.first_name}} {{passenger.familiy_name}}</label>
                    </div>
                </div>

            </div>
            <div v-else class="flex-col" :class="{'hidden': !isMobile()}">
                <div class="flex-grow" v-for="(passenger, index) in passengers" @click="Toggle_Passenger(passenger)">
                    <div class="flex items-center">
                        <input :id="passenger.passenger_identifier" type="checkbox" :checked="Passenger_Selected(passenger)" class="ml-10 focus:ring-action -mt-1 h-4 w-4 text-action border-grey-light rounded">
                        <label :for="passenger.passenger_identifier" class="ml-3 block text-sm cursor-pointer">{{passenger.first_name}} {{passenger.familiy_name}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./existing_passengers.ts"></script>